// Modules
import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { AuthContext } from "../../../Context/AuthContext";
import { CardContext } from "../../../Context/CardContext";
// Components
import MobileSideBar from "../SideBar/Mobile/MobileSideBar";
// Styles
import Styles from "./Styles/Header.module.css";
// Images
import userImage from "../../../Assets/Icons/user.png";
import logoImage from "../../../Assets/Images/logo.png";
import searchGif from "../../../Assets/Gif/search.gif";
import closeImage from "../../../Assets/Icons/close.png";
import menuImage from "../../../Assets/Icons/menu-light.png";
import dashboardImage from "../../../Assets/Icons/dashboard (2).png";
import shopImage from "../../../Assets/Icons/shop.png";
import exitImage from "../../../Assets/Icons/exit.png";
import bellIcon from "../../../Assets/Icons/bell.png";
import closeIcon from "../../../Assets/Icons/white-rectangled-close.png";
import buySubscription from "../../../Assets/Icons/subscription.png";
import convertNumbersToPersian from "../../../Utils/convertNumbersToPersian";
import { useEffect } from "react";
import {
  getArticles,
  getBooks,
  getNotifications,
} from "../../../Services/getData";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Header = () => {
  const { isLoggedIn, logout } = useContext(AuthContext);
  const { itemsCount } = useContext(CardContext);
  const [notifications, setNotifications] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showMobileSidebar, setShowMobileSidebar] = useState(false);
  const [searchedContent, setSearchedContent] = useState([]);
  const [allContents, setAllContents] = useState([]);
  const [showNotifs, setShowNotifs] = useState(false);
  const { location } = useHistory();

  useEffect(() => {
    const api = async () => {
      try {
        const { data: visualsList } = await getArticles("visual");
        setAllContents((prev) => [...prev, ...visualsList.article]);
      } catch (error) {
        console.log(error.response.data.message);
      }
      try {
        const { data: textualsList } = await getArticles("textual");
        setAllContents((prev) => [...prev, ...textualsList.article]);
      } catch (error) {
        console.log(error.response.data.message);
      }
      try {
        const { data: quarterlysList } = await getArticles("quarterly");
        setAllContents((prev) => [...prev, ...quarterlysList.article]);
      } catch (error) {
        console.log(error.response.data.message);
      }
      try {
        const { data: booksList } = await getBooks();
        setAllContents((prev) => [...prev, ...booksList.books]);
      } catch (error) {
        console.log(error.response.data.message);
      }
    };
    if (showModal && allContents.length === 0) {
      api();
    } else {
      setSearchedContent([]);
      setAllContents([]);
    }
  }, [showModal]);

  useEffect(() => {
    const api = async () => {
      const { data } = await getNotifications();
      setNotifications(data.notifications);
    };
    api();
  }, []);

  const handleSearch = (e) => {
    if (e.target.value.length > 0) {
      const searchTerm = e.target.value.toLowerCase();

      const filteredContentSearched = allContents.filter((content) => {
        const lowerCaseTitle = content.title.toLowerCase();
        return lowerCaseTitle.includes(searchTerm);
      });

      setSearchedContent(filteredContentSearched);
    } else {
      setSearchedContent([]);
    }
  };

  return (
    <motion.div
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      className={Styles.container}
    >
      {showModal && (
        <motion.div
          initial={{ y: -1000 }}
          animate={{ y: 0 }}
          transition={{ duration: 0.5 }}
          className={Styles.modal}
        >
          <div
            className={Styles.closeModal}
            onClick={() => setShowModal(false)}
          >
            <img src={closeImage} alt="" />
          </div>
          <div className={Styles.searchContainer}>
            <input
              className={Styles.search}
              type="text"
              placeholder="جستجو کنید"
              name="name"
              id="name"
              onChange={handleSearch}
              // required
            />
            <label htmlFor="name" className={Styles.form__label}>
              جستجو کنید
            </label>
          </div>
          <div className={Styles.searcheItemsContainer}>
            {searchedContent.map((item, index) => (
              <Link
                key={index}
                to={`/article/${item.kind}/${item._id}`}
                className={Styles.searchedItem}
              >
                <img
                  src={`${process.env.REACT_APP_PUBLIC_PATH}uploads/images/${
                    !item.frontCover ? item.image : item.frontCover
                  }`}
                  alt=""
                />
                <h3>{item.title}</h3>
                <h3>
                  {item.kind === "textual"
                    ? "مقاله متنی"
                    : item.kind === "visual"
                    ? "مقاله تصویری"
                    : item.kind === "quarterly"
                    ? "فصلنامه"
                    : "کتاب"}
                </h3>
              </Link>
            ))}
          </div>
        </motion.div>
      )}
      <div className={Styles.left}>
        {isLoggedIn ? (
          <div className={Styles.loggedInUser}>
            <img src={userImage} alt="" />
            <div className={Styles.hoverUser}>
              <a
                className={Styles.menuImage}
                onClick={() => setShowMobileSidebar(true)}
              >
                منو <img src={menuImage} alt="" />
              </a>
              <Link to="/users/panel">
                داشبورد <img src={dashboardImage} alt="" />
              </Link>
              <Link to="/users/panel/cart">
                سبد خرید <img src={shopImage} alt="" />{" "}
                <h6>{convertNumbersToPersian(itemsCount.toString())}</h6>
              </Link>
              {/* <Link to="/users/panel/cart">
                خرید اشتراک <img src={buySubscription} alt="" />{" "}
              </Link> */}
              <Link to="/" onClick={logout}>
                خروج <img src={exitImage} alt="" />
              </Link>
            </div>
          </div>
        ) : (
          <div className={Styles.loggedOutUser}>
            <h2
              className={Styles.mobileHeaderFlag}
              onClick={() => setShowMobileSidebar(true)}
            >
              <img src={menuImage} alt="" />
            </h2>
            <Link className={Styles.login} to="/users/login">
              ورود
            </Link>
            <Link
              className={`${Styles.register} ${Styles.active}`}
              to="/users/register"
            >
              ثبت نام
            </Link>
          </div>
        )}
        {location.pathname === "/" && (
          <div className={Styles.notifications}>
            <img
              className={Styles.bell}
              onClick={() => setShowNotifs(true)}
              src={bellIcon}
              alt=""
            />
            {showNotifs && (
              <>
                <div className={Styles.triangle}></div>
                <div
                  className={Styles.notificationsListContainer}
                  style={
                    (isLoggedIn ? {} : { left: "-120px" },
                    window.innerWidth < 761
                      ? notifications.length === 0
                        ? {}
                        : notifications.length === 1
                        ? { top: "-139px" }
                        : notifications.length === 2
                        ? { top: "-219px" }
                        : notifications.length === 3
                        ? { top: "-297px" }
                        : { top: "-374px" }
                      : {})
                  }
                >
                  <div className={Styles.title}>
                    <h4>اطلاعیه ها</h4>
                    <div
                      className={Styles.closeIcon}
                      onClick={() => setShowNotifs(false)}
                    >
                      <img src={closeIcon} alt="" />
                    </div>
                  </div>
                  {notifications.map((notif, index) => (
                    <motion.div
                      initial={{ y: -80, opacity: 0 }}
                      animate={{ y: 0, opacity: 1 }}
                      transition={{ duration: 0.5, delay: index / 7 }}
                      className={Styles.item}
                      key={notif._id}
                    >
                      <Link
                        className={Styles.item}
                        to={`/${
                          notif.kind === "book"
                            ? "library/single-book"
                            : notif.kind === "textual"
                            ? "article/journal"
                            : "article/image-articles"
                        }/${notif.id}`}
                      >
                        <div className={Styles.postImage}>
                          <img
                            src={`${process.env.REACT_APP_PUBLIC_PATH}/uploads/images/${notif.image}`}
                            alt=""
                          />
                        </div>
                        <div className={Styles.postDetails}>
                          <h3>
                            {notif.title.length > 30
                              ? notif.title.slice(0, 30) + "..."
                              : notif.title}
                          </h3>
                          <h5>
                            {notif.category.length > 30
                              ? notif.category.slice(0, 30) + "..."
                              : notif.category}
                          </h5>
                        </div>
                      </Link>
                    </motion.div>
                  ))}
                </div>
              </>
            )}
          </div>
        )}
      </div>
      <div className={Styles.right}>
        <div className={Styles.search} onClick={() => setShowModal(true)}>
          <h3>جستجو</h3>
          <div className={Styles.separator}></div>
          <img src={searchGif} alt="" />
        </div>
        <Link to="/" className={Styles.logo}>
          <img src={logoImage} alt="" />
        </Link>
      </div>
      {showMobileSidebar && (
        <motion.div
          initial={{ x: -500 }}
          animate={{ x: 0 }}
          transition={{ duration: 0.5 }}
          className={Styles.mobileSideBarContainer}
        >
          <MobileSideBar />
          <img
            className={Styles.closeImage}
            onClick={() => setShowMobileSidebar(false)}
            src={closeImage}
            alt=""
          />
        </motion.div>
      )}
    </motion.div>
  );
};

export default Header;
